import { useCallback } from 'react';

import { queryClient } from '@/src/lib/react-query/react-query';

import {
  getLibraryItemActivitiesQueryKey,
  useGetLibraryItemActivities,
} from './api/getLibraryItemActivities';
import {
  getLibraryItemCommentsQueryKey,
  useGetLibraryItemComments,
} from './api/getLibraryItemComments';

export type useInfoPanelQueriesProps = {
  libraryItemId: number;
  sourceId: number;
};

export const useInfoPanelQueries = ({ libraryItemId, sourceId }: useInfoPanelQueriesProps) => {
  const handleCommentAdded = useCallback(
    (response) => {
      queryClient.setQueryData([...getLibraryItemCommentsQueryKey.list(sourceId)], (prev: any) => {
        return {
          ...prev,
          data: [...prev.data, response.data.result],
        };
      });

      queryClient.invalidateQueries([...getLibraryItemActivitiesQueryKey.list(sourceId)]);
    },
    [sourceId]
  );

  return {
    comments: {
      useCommentsQuery: () => useGetLibraryItemComments({ sourceId }),
      onCommentAdded: handleCommentAdded,
    },
    useActivityLogsQuery: () => useGetLibraryItemActivities({ libraryItemId }),
  };
};
